import React from 'react';
import {
  CardStyleInterpolators,
  createStackNavigator,
} from '@react-navigation/stack';
import {makeId} from '../../utils';
import {E_NAVIGATION_DESTINATIONS} from '../../@types';
import { DoorLogDetail, DoorLogsList } from './screens';

const Stack = createStackNavigator();

const DoorLogsNavigator = () => {
  const options = {
    headerShown: false,
    cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
  };

  return (
    <Stack.Navigator>
      <Stack.Screen
        name={E_NAVIGATION_DESTINATIONS.DOOR_LOGS_LIST}
        component={DoorLogsList}
        options={{...options, animationTypeForReplace: 'pop'}}
        key={makeId(12)}
      />
 
      <Stack.Screen
        name={E_NAVIGATION_DESTINATIONS.DOOR_LOG_DETAILS}
        component={DoorLogDetail}
        options={{...options, animationTypeForReplace: 'pop'}}
        key={makeId(12)}
      />
    </Stack.Navigator>
  );
};

export const doorLogScreens = {
  [E_NAVIGATION_DESTINATIONS.DOOR_LOGS_LIST] :"/doorLogsList",
  [E_NAVIGATION_DESTINATIONS.DOOR_LOG_DETAILS] :"/doorLogDetails",
}

export default DoorLogsNavigator;
